module.exports = __webpack_public_path__ + "static/media/facebook.bd38a82f.svg";